// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"15":"f55a4482","798":"b16b4f2f"}[chunkId] + ".css";
};